import React from 'react';
import DocumentTitle from 'react-document-title';
import ReactToPrint from 'react-to-print';

import {getSettings, getReservation} from '../data/get-from-sheet';

import './thankYouPage.css';
import 'font-awesome/css/font-awesome.min.css';
import Loading from './Loading';
import PrintableThankYouRegion from './PrintableThankYouRegion';

class ThankYouPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            reservationId: props.match.params.reservationId,
            sheetId: props.match.params.sheetId
        };
        this.captureRef = this.captureRef.bind(this);
    }

    async componentDidMount() {
        const settingsPromise = getSettings(this.state.sheetId);
        const reservationPromise = getReservation(this.state.sheetId, this.state.reservationId);
        const [settings, reservation] = await Promise.all([settingsPromise, reservationPromise]);

        this.setState(() => ({
            loading: false,
            reservation,
            settings
        }));
    }

    captureRef(el) {
        this.PrintableThankYouRegionComponentRef = el;
    }

    render() {
        const details = this.state.settings;

        return this.state.loading
            ? <Loading />
            : (
                <DocumentTitle title={`${details.window.title}: Thank You!`}>
                    <main>
                        <p>
                            <img
                                alt="header"
                                className="ThankYouPage-img"
                                src={details.thankYou.banner.src}
                            />
                        </p>
                        <ReactToPrint
                            content={() => this.PrintableThankYouRegionComponentRef}
                            trigger={() => <button type="button">{'Print This Information'}</button>}
                        />
                        <PrintableThankYouRegion
                            ref={this.captureRef}
                            reservation={this.state.reservation}
                            details={details}
                        />
                    </main>
                </DocumentTitle>
            );
    }
}

export default ThankYouPage;



// WEBPACK FOOTER //
// ./src/event/ThankYouPage.js